module.exports = __webpack_public_path__ + "img/in_purchase.4d634361.png";